// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fcXy","colBig":"styles_colBig__2X8kE","colSmall":"styles_colSmall__1jn2p"};